import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useLang } from "../context/LangContext";

export default function Nav() {
  const { lang, setLang, t } = useLang();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    if (loc.pathname !== "/") {
      window.location.href = `/#${id}`;
      return;
    }
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav
      data-testid="main-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "backdrop-blur-xl bg-[#050505]/85 border-b border-white/5" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between h-16 lg:h-20">
        <Link to="/" data-testid="logo-link" className="font-display text-xl lg:text-2xl tracking-[0.25em] text-white">
          INTIMO<span className="text-[#00E5FF]">.</span>MODELS
        </Link>

        <div className="hidden lg:flex items-center gap-10">
          <button data-testid="nav-home" onClick={() => scrollTo("home")} className="text-[0.75rem] tracking-[0.2em] uppercase text-neutral-300 hover:text-[#00E5FF] transition-colors">{t.nav.home}</button>
          <button data-testid="nav-requirements" onClick={() => scrollTo("requirements")} className="text-[0.75rem] tracking-[0.2em] uppercase text-neutral-300 hover:text-[#00E5FF] transition-colors">{t.nav.requirements}</button>
          <button data-testid="nav-how" onClick={() => scrollTo("how")} className="text-[0.75rem] tracking-[0.2em] uppercase text-neutral-300 hover:text-[#00E5FF] transition-colors">{t.nav.how}</button>
          <div className="flex items-center gap-1 border border-white/10 px-1 py-1">
            <button
              data-testid="lang-en"
              onClick={() => setLang("en")}
              className={`text-[0.7rem] tracking-[0.2em] uppercase px-2 py-1 transition-colors ${lang === "en" ? "text-[#00E5FF]" : "text-neutral-500"}`}
            >EN</button>
            <button
              data-testid="lang-fr"
              onClick={() => setLang("fr")}
              className={`text-[0.7rem] tracking-[0.2em] uppercase px-2 py-1 transition-colors ${lang === "fr" ? "text-[#00E5FF]" : "text-neutral-500"}`}
            >FR</button>
            <button
              data-testid="lang-pt"
              onClick={() => setLang("pt")}
              className={`text-[0.7rem] tracking-[0.2em] uppercase px-2 py-1 transition-colors ${lang === "pt" ? "text-[#00E5FF]" : "text-neutral-500"}`}
            >PT</button>
          </div>
          <button data-testid="nav-apply-btn" onClick={() => scrollTo("apply")} className="btn-cyan">
            {t.nav.apply}
          </button>
        </div>

        <button data-testid="nav-mobile-toggle" className="lg:hidden text-white" onClick={() => setOpen(!open)}>
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#050505] border-t border-white/5 px-6 py-6 flex flex-col gap-5">
          <button onClick={() => scrollTo("home")} className="text-left text-sm tracking-[0.2em] uppercase text-neutral-300">{t.nav.home}</button>
          <button onClick={() => scrollTo("requirements")} className="text-left text-sm tracking-[0.2em] uppercase text-neutral-300">{t.nav.requirements}</button>
          <button onClick={() => scrollTo("how")} className="text-left text-sm tracking-[0.2em] uppercase text-neutral-300">{t.nav.how}</button>
          <div className="flex items-center gap-2">
            <button onClick={() => setLang("en")} className={`text-xs tracking-[0.2em] uppercase px-3 py-2 border ${lang === "en" ? "border-[#00E5FF] text-[#00E5FF]" : "border-white/10 text-neutral-500"}`}>EN</button>
            <button onClick={() => setLang("fr")} className={`text-xs tracking-[0.2em] uppercase px-3 py-2 border ${lang === "fr" ? "border-[#00E5FF] text-[#00E5FF]" : "border-white/10 text-neutral-500"}`}>FR</button>
            <button onClick={() => setLang("pt")} className={`text-xs tracking-[0.2em] uppercase px-3 py-2 border ${lang === "pt" ? "border-[#00E5FF] text-[#00E5FF]" : "border-white/10 text-neutral-500"}`}>PT</button>
          </div>
          <button onClick={() => scrollTo("apply")} className="btn-cyan w-fit">{t.nav.apply}</button>
        </div>
      )}
    </nav>
  );
}
